angular.module('picmonicng').component('homeFreemium', {
  templateUrl: '/templates/app/components/home-freemium/home-freemium.html',
  bindings: {},
  controller: [
    'TokenService',
    'UserService',
    'MarketOptionsConfig',
    function (TokenService, UserService, MarketOptionsConfig) {
      var ctrl = this;
      ctrl.TokenService = TokenService;
      ctrl.UserService = UserService;
      ctrl.market = MarketOptionsConfig.getMarketById(UserService.user.lead).name;
    },
  ],
});
